<div>
  <!-- Multi-select dropdown -->
  <ng-container *ngIf="dropdownType === 'multiple'">
    <ng-select
      [dropdownPosition]="dropdownPosition"
      (change)="changeFn()"
      [items]="inputItems"
      [multiple]="true"
      [closeOnSelect]="false"
      [searchable]="true"
      [clearable]="false"
      bindLabel="{{ bindLabel }}"
      bindValue="{{ bindVal }}"
      appearance="outline"
      placeholder="{{ label }}"
      [ngModelOptions]="{ standalone: true }"
      [clearable]="true"
      [(ngModel)]="selectedItems">
      <ng-template ng-multi-label-tmp>
        {{ type != 'foremanSelection' ? selectedItems?.length : '' }} {{ label }}
      </ng-template>
      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
        <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" />
        {{ item[getBindLabel()] | uppercase }}
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item[getBindLabel()] }}
        <span class="phone-number" *ngIf="item.phone"><i class="fa fa-phone"></i> {{ item.phone }}</span>
      </ng-template>
    </ng-select>
  </ng-container>

  <!-- Single select dropdown -->
  <ng-container *ngIf="dropdownType === 'single'">
    <ng-select
      (change)="changeFn()"
      [items]="inputItems"
      (clear)="reloadOptions()"
      [closeOnSelect]="true"
      [searchable]="true"
      [clearable]="false"
      bindLabel="{{ bindLabel }}"
      bindValue="{{ bindVal }}"
      appearance="outline"
      placeholder="{{ label }}"
      [ngModelOptions]="{ standalone: true }"
      [clearable]="true"
      [virtualScroll]="getVirtualScroll()"
      [(ngModel)]="selectedItems">
      <ng-template ng-label-tmp let-item="item" let-item$="item$">
        <ng-container>
          {{ item[getBindLabel()] }}
        </ng-container>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <span>{{ item[getBindLabel()] }} </span>
      </ng-template>
    </ng-select>
  </ng-container>

  <!-- Used for flat arrays of options. -->
   <ng-container *ngIf="dropdownType === 'flat'">
    <ng-select
      (change)="changeFn()"
      [items]="inputItems"
      (clear)="reloadOptions()"
      [closeOnSelect]="true"
      [searchable]="true"
      [clearable]="false"
      appearance="outline"
      placeholder="{{ label }}"
      [ngModelOptions]="{ standalone: true }"
      [clearable]="true"
      [virtualScroll]="getVirtualScroll()"
      [(ngModel)]="selectedItems">
      <ng-template ng-label-tmp let-item="item" let-item$="item$">
        <ng-container>
          {{ item }}
        </ng-container>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <span>{{ item }} </span>
      </ng-template>
    </ng-select>
  </ng-container>
</div>
